import variant0 from './variant0';
import { variant1, variant2 } from './variant1-2';
import variant3 from './variant3';
import variant4 from './variant4';

export default () => {
    variant0();
    window.odds = { variant1, variant2, variant3, variant4 };
};



// WEBPACK FOOTER //
// ./lib/js/modules/odds/index.js